<template>
    <div class="container-fluid">
        <font-awesome-icon icon="sync" spin v-if="loading"/>
        <div class="alert alert-danger" role="alert" v-if="hasError">
            <b>Fehler</b><br>
            Daten konnten nicht geladen werden!
        </div>

        <div class="card border-danger margin-top" v-if="unmergedProjects.length > 0">
            <div class="card-header">
                Not merged projects
            </div>
            <div class="card-body">
                <table class="table table-bordered">
                    <thead>
                    <th>Kunde</th>
                    <th>Branch / Redmine</th>
                    <th>Gitlab core</th>
                    <th>Gitlab customer</th>
                    </thead>
                    <tbody>
                    <tr v-for="unmergedProject in unmergedProjects">
                        <th>{{unmergedProject.name}}</th>
                        <td>
                            <a target="_blank" v-bind:href="'https://redmine.etailer.de/issues/' + unmergedProject.status.currentRedmineId">{{unmergedProject.status.currentRedmineId}}</a>
                        </td>
                        <td>
                            <a target="_blank" v-bind:href="'https://gitlab.etailer.de/etailer/core/branches/all?utf8=%E2%9C%93&search=' + unmergedProject.status.currentRedmineId">Link</a>
                        </td>
                        <td>
                            <a target="_blank" v-bind:href="'https://gitlab.etailer.de/'+getCustomerName(unmergedProject.identifier)+'/customer_'+getCustomerName(unmergedProject.identifier)+'/branches/all?utf8=%E2%9C%93&search=' + unmergedProject.status.currentRedmineId">Link</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
  import Api from '../Api'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

  export default {
    name: 'project-status-page',
    components: {
      FontAwesomeIcon
    },
    methods: {
      getCustomerName(customerIdentifier) {
        if (customerIdentifier === 'gudrun-sjoeden') {
          return 'gudrunsjoeden'
        }
        if (customerIdentifier === 'applicas-nette-papier') {
          return 'nette'
        }

        return customerIdentifier;
      }
    },
    computed: {
      unmergedProjects() {
        let out = [];
        if (this.projects.length > 0) {
          for (let i = 0; i < this.projects.length; i++) {
            let project = this.projects[i];
            if (!project.status.isCurrentMergedInMaster && project.status.currentRedmineId > 0) {
              out.push(project);
            }
          }
        }
        return out;
      }
    },
    data: function () {
      return {
        loading: false,
        hasError: false,
        projects: []
      }
    },
    mounted: function () {
      this.loading = true
      this.hasError = false

      Api.getAllProjects().then((projects) => {
        this.projects = projects
        this.loading = false
      }).catch((err) => {
        if (err === 'FAILD') {
          this.hasError = true
          this.loading = false
        } else if (err === 'UNAUTHORIZED') {
          this.$router.push('/login')
        }
      })
    }
  }
</script>

<style scoped>
    .margin-top {
        margin-top: 1rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/NotMergedProjects.vue